export async function writeJsonLd(schema, stream) {
    await stream.write(JSON.stringify(schema, undefined, 2));
    await stream.close();
}
//# sourceMappingURL=json-ld-writer.js.map